import React from "react";

const AudioFull = ({ surah }) => {
  return (
    <div>
      <audio controls className="audio-player" src={surah.audioFull["05"]} />
    </div>
  );
};

export default AudioFull;
